import axios from 'axios';
import {addVisitationAuth} from './visitation_auth';

const AuthAxios = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json', 'Access-Control-Allow-Origin' : '*' },
})

addVisitationAuth(AuthAxios);
export default AuthAxios;